import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SidebarLeftExpandIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SidebarLeftExpand",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.571 4.572H3.43A3.43 3.43 0 0 0 0 8v16a3.43 3.43 0 0 0 3.429 3.429H28.57A3.43 3.43 0 0 0 32 24V8a3.43 3.43 0 0 0-3.429-3.428M29.714 24c0 .631-.513 1.143-1.143 1.143H10.352V6.858h18.22c.63 0 1.142.512 1.142 1.142z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M18.14 22c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l3.76-3.76-3.76-3.76a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l4.57 4.57c.45.45.45 1.17 0 1.62l-4.57 4.57c-.22.22-.52.33-.81.33M9 27.71c-.63 0-1.14-.51-1.14-1.14V6a1.14 1.14 0 1 1 2.28 0v20.57c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.43 27.71H3.29c-1.89 0-3.43-1.54-3.43-3.43v-16c0-1.89 1.54-3.43 3.43-3.43h25.14c1.89 0 3.43 1.54 3.43 3.43v16c0 1.89-1.54 3.43-3.43 3.43M3.29 7.14c-.63 0-1.14.51-1.14 1.14v16c0 .63.51 1.14 1.14 1.14h25.14c.63 0 1.14-.51 1.14-1.14v-16c0-.63-.51-1.14-1.14-1.14z"
      })]
    })
  }));
};
SidebarLeftExpandIcon.displayName = 'SidebarLeftExpandIcon';